import React from "react";
import {store} from "./store";
import { Provider } from "react-redux";
import { CartProvider } from "../context/CartContext";
import CartDrawer from "../components/Cart/CartDrawer";

const ReduxWrapper = ({ element }) => (
    <Provider store={store}>
        <CartProvider>
            {element}
            <CartDrawer />
        </CartProvider>
    </Provider>
);

export default ReduxWrapper;
